import { useState } from "react";

export const useStepButtonScheduleDetailV2 = () => {
  const [step, setStep] = useState(1);
  return { step, setStep };
};
